import { styled } from "@mui/material";

const StyledHighlightedText = styled("span")(() => ({
  backgroundColor: "#FFF6CB",
}));

interface HighlightedTypographyProps {
  children: React.ReactNode;
}

export const HighlightedTypography: React.FC<HighlightedTypographyProps> = ({
  children,
  ...props
}) => {
  return <StyledHighlightedText {...props}>{children}</StyledHighlightedText>;
};

export default HighlightedTypography;
